import * as React from 'react';
import { SVGProps } from 'react';

const IconFunnelRemoveSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2h20v2.24a2 2 0 0 1-.505 1.328l-6.99 7.864A2 2 0 0 0 14 14.76V21l-4 2v-8.24a2 2 0 0 0-.505-1.328l-6.99-7.864A2 2 0 0 1 2 4.24V2Zm7.172 3.828 1.414 1.415-1.414 1.414 1.414 1.414L12 8.657l1.414 1.414 1.414-1.414-1.414-1.414 1.414-1.415-1.414-1.414L12 5.828l-1.414-1.414-1.414 1.414Z"
    />
  </svg>
);
export default IconFunnelRemoveSizeM;
